'use client'
import MainLayout from '@/components/Layouts/Main'
import React, { useEffect, useRef, useState } from "react";
import { home } from '@/helpers/content/id/home';
import Faq from '@/components/Faq/Faq';
import { faqTax } from '@/helpers/content/id/services/tax/faq';
import CallToAction from '@/components/CallToAction/CallToAction';
import TaxServices from '@/components/PageServices/Tax/TaxServices';
import MiniCard from '@/components/MiniCard/MiniCard'
import Image from "next/image"
import { homeFinops } from '@/helpers/content/id/services/financial-operational/homeFinops';
import ServicesFinOps from '@/components/Sections/FinOps/ServicesFinOps';
import { faqFinOps } from '@/helpers/content/id/services/financial-operational/faq';
import { listReasonsFinOps } from '@/helpers/content/id/services/financial-operational/reasons';
import { useRouter } from 'next/router';
import HomeSection from '@/components/Sections/FinOps/HomeSection';
import { t } from 'i18next';
import Reasons from '@/components/PageServices/FinOps/Reasons';
import { faqContact } from '@/helpers/content/id/services/financial-operational/contact';
import * as ga from "@/libs/analytics";
import { getCookie } from 'cookies-next';
import { useTranslation } from 'react-i18next';

export default function FinancialOperational() {
    const { t } = useTranslation();
    const [isShowBar, setisShowBar] = useState(false)
  const homeRef = useRef()
  const pricingRef = useRef()
  const servicesRef = useRef()
  const servicesMobileRef = useRef([])
  const servicesMainMobileRef = useRef()
  const contactRef = useRef()
  const clientRef = useRef()
  const [nextTab, setnextTab] = useState(0)
  const [nextTabMobile, setnextTabMobile] = useState(0)
  const [servicesElementScroll, setservicesElementScroll] = useState(0)
  const lang = getCookie('NEXT_LOCALE') || 'id'
  const router = useRouter()

  useEffect(() => {
    const head = document.head;
    const script = document.createElement("script");
    script.innerHTML = `
      setTimeout(function(){var a=document.createElement("script");
      var b=document.getElementsByTagName("script")[0];
      a.src=document.location.protocol+"//script.crazyegg.com/pages/scripts/0055/6070.js?"+Math.floor(new Date().getTime()/3600000);
      a.async=true;a.type="text/javascript";b.parentNode.insertBefore(a,b)}, 1);
    `;
    head.appendChild(script);
    const handleRouteChange = (url) => {
      ga.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  useEffect(() => {
    const getLocalStorage = JSON.parse(localStorage.getItem("type"))
    if (getLocalStorage) {
      console.log("local storage",getLocalStorage)
      if (getLocalStorage.index) {
        if (getLocalStorage.scrollTo == "services") {
          setnextTab(getLocalStorage.index)
        }else if(getLocalStorage.scrollTo == "services-mobile"){
          setnextTabMobile(getLocalStorage.index)
        }
        moveToSection(getLocalStorage.scrollTo, getLocalStorage.index)
      }else{
        moveToSection(getLocalStorage.scrollTo)
      }
    }
    localStorage.removeItem("type")
  }, [])
  

  const moveToSection = (type, index = 0) => {
    if (type == "pricingRef") {
      window.scrollTo({top: pricingRef.current.offsetTop, behavior:"smooth" })
    }else if(type == "client"){
      setisShowBar(false)
      window.location.href = "/"
      localStorage.setItem("type",JSON.stringify({scrollTo:"client"}))
    }else if (type == "services") {
      setisShowBar(false)
      // setnextTab(index)
      window.scrollTo({
        top: servicesRef.current.offsetTop, 
        behavior:"smooth"
      })
    }
    else if (type == "services-mobile") {
      console.log(index)
      setservicesElementScroll(prev => prev > 0 ? prev : servicesMainMobileRef.current.getBoundingClientRect().top - 100)
      setisShowBar(false)
      setnextTabMobile(index)
      // setTimeout(() => {
      //   window.scrollTo({
      //     top: servicesMainMobileRef.current.getBoundingClientRect().top,
      //     bottom: servicesMainMobileRef.current.getBoundingClientRect().bottom,
      //     behavior:"smooth"
      //   })
      // }, 100);
    }
    else if(type == "article"){
      window.open("https://blog.ledgerowl.com/","_blank")
    }else if(type == "home") { 
      window.scrollTo({
        top: homeRef.current.offsetTop,
        behavior:"smooth"
      })
    }else if(type == "contact") { 
      window.scrollTo({
        top: contactRef.current.offsetTop,
        behavior:"smooth"
      })
    }else if(type == "consultation"){
      window.scrollTo({
        top: contactRef.current.offsetTop,
        behavior:"smooth"
      })
      // window.open("https://api.whatsapp.com/send?phone=6281287889023&text=%20%20Hi!%20Can%20I%20ask%20more%20on%20ledgerowl%20services%20%3f","_blank")
    }
  }
  return (
    <MainLayout
      setnextTab={setnextTab}
      setnextTabMobile={setnextTabMobile}
      setisShowBar={setisShowBar}
      isShowBar={isShowBar}
      moveToSection={moveToSection}
      textWa={t("floating_message_service_finance")}
    >
      <HomeSection 
          homeRef={homeRef} 
          moveToSection={moveToSection}
          home={homeFinops}
          widthContainer={"max-w-[1280px]"}
          widthDescription={"lg:w-[100%] xl:w-[85%]"}
          cardStackThree = {homeFinops.text.in_pict.first_card}
          miniCard = {homeFinops.text.in_pict.second_card}
       >
        <div className={`relative w-full lg:w-[90rem] flex justify-end h-full`}>
          <div className='md:hidden flex lg:hidden h-full'>
              <Image src={homeFinops.imageMobile} />
          </div>
          <div className='md:flex hidden lg:hidden h-full'>
              <Image src={homeFinops.imageTablet} />
          </div>
          <div className='md:hidden hidden lg:flex h-full'>
              <Image src={homeFinops.imageDesktop} />
          </div>
          <div className='hidden overflow-hidden lg:flex'>
            <div className={`z-20 drop-shadow-xl absolute md:flex md:justify-center top-5 left-5 lg:top-20 md:top-8 md:w-[60rem] md:-left-[22rem] lg:-left-4 flex lg:w-auto items-center`}>
              <MiniCard
                main_title={t('finops_home_first_card_main_title')}
                second_title={t('finops_home_first_card_second_title')}
                third_title={t('finops_home_first_card_third_title')}
                second_description={t('finops_home_first_card_second_description')}
                third_description={t('finops_home_first_card_third_description')}
              />
            </div>
            <div className={`z-20 bottom-20 drop-shadow-xl right-20 absolute flex`}>
                <MiniCard
                  main_title={t('finops_home_second_card_main_title')}
                  second_title={t('finops_home_second_card_second_title')}
                  third_title={t('finops_home_second_card_third_title')}
                  second_description={t('finops_home_second_card_second_description')}
                  third_description={t('finops_home_second_card_third_description')}
                />
            </div>
          </div>
          <div className='hidden overflow-hidden md:flex h-full w-full justify-center space-y-32 space-x-32 absolute z-20 py-28 top-0 lg:hidden'>
          <div className={`z-20 drop-shadow-xl absolute md:flex md:justify-center top-5 left-5 lg:top-20 md:top-8 md:w-[60rem] md:-left-[22rem] lg:-left-24 flex lg:w-auto items-center`}>
              <MiniCard
                main_title={t('finops_home_first_card_main_title')}
                second_title={t('finops_home_first_card_second_title')}
                third_title={t('finops_home_first_card_third_title')}
                second_description={t('finops_home_first_card_second_description')}
                third_description={t('finops_home_first_card_third_description')}
              />
            </div>
            <div className={`z-20 left-5 bottom-10 md:-left-20 md:bottom-20 lg:-left-14 drop-shadow-xl absolute flex`}>
                <MiniCard
                  main_title={t('finops_home_second_card_main_title')}
                  second_title={t('finops_home_second_card_second_title')}
                  third_title={t('finops_home_second_card_third_title')}
                  second_description={t('finops_home_second_card_second_description')}
                  third_description={t('finops_home_second_card_third_description')}
                />
            </div>
          </div>
          <div className='flex overflow-hidden md:hidden h-full w-full absolute z-20 space-y-[86px] px-3 py-16 top-0 border-semantic-negative-900 lg:hidden'>
          <div className={`z-20 drop-shadow-xl absolute md:flex md:justify-center top-5 left-5 lg:top-20 md:top-10 md:w-[60rem] md:-left-[22rem] lg:-left-24 flex lg:w-auto items-center`}>
              <MiniCard
                main_title={t('finops_home_first_card_main_title')}
                second_title={t('finops_home_first_card_second_title')}
                third_title={t('finops_home_first_card_third_title')}
                second_description={t('finops_home_first_card_second_description')}
                third_description={t('finops_home_first_card_third_description')}
              />
            </div>
            <div className={`z-20 left-5 bottom-10 md:-left-20 md:bottom-20 lg:-left-14 drop-shadow-xl absolute flex`}>
                <MiniCard
                  main_title={t('finops_home_second_card_main_title')}
                  second_title={t('finops_home_second_card_second_title')}
                  third_title={t('finops_home_second_card_third_title')}
                  second_description={t('finops_home_second_card_second_description')}
                  third_description={t('finops_home_second_card_third_description')}
                />
            </div>
          </div>
        </div>
      </HomeSection>
      <div className='relative flex max-w-[1280px] lg:mx-auto lg:container flex-col w-full px-4 py-16 lg:px-8 lg:py-[100px] bg-base-white'>
        <Reasons list={listReasonsFinOps}/>
      </div>
      <ServicesFinOps lang={lang} />
      <Faq faq={faqFinOps}/>
      <CallToAction contact={faqContact} service={"Finansial"} contactRef={contactRef} textWa={t("floating_message_service_finance")} />
    </MainLayout>
  )
}
